module.exports = __webpack_public_path__ + "img/word_test_cover.337df608.png";